import React from 'react'
import Retour from '../components/Retour'

function Pieta() {
  return (
    <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Lili et son fils Mateo ont une relation fusionnelle qui les rend dépendants l’un de l’autre. Ils se complaisent dans une réalité suffocante jusqu’au jour où l’un d’entre eux est atteint d’une maladie grave. La simple idée d’être séparés les conduit à développer une version d’eux-mêmes la plus sombre et toxique qui soit.</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
    </div>
    </div>
  )
}

export default Pieta